(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slpstrm-wholesale"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  /* ---------- helpers ---------- */

  // Australian Business Number checksum (official ATO algorithm)
  function isValidABN(raw) {
    var d = String(raw).replace(/\s+/g, '');
    if (!/^\d{11}$/.test(d)) return false;
    var w = [10, 1, 3, 5, 7, 9, 11, 13, 15, 17, 19];
    var sum = 0;
    for (var i = 0; i < 11; i++) {
      var n = parseInt(d.charAt(i), 10);
      if (i === 0) n -= 1;
      sum += n * w[i];
    }
    return sum % 89 === 0;
  }

  function isValidEmail(v) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v);
  }

  function isValidPhone(v) {
    var digits = v.replace(/[^\d]/g, '');
    return digits.length >= 8 && digits.length <= 15;
  }

  /* ---------- per-field validation ---------- */

  function validateField(input) {
    var value = (input.value || '').trim();
    var key = input.id.replace(/^.*-/, '');
    var msg = '';

    if (input.required && !value) {
      msg = 'This field is required.';
    } else if (value) {
      if (input.type === 'email' && !isValidEmail(value)) msg = 'Enter a valid email address.';
      else if (input.type === 'tel' && !isValidPhone(value)) msg = 'Enter a valid phone number.';
      else if (input.hasAttribute('data-slpw-abn') && !isValidABN(value)) msg = 'Enter a valid 11-digit ABN.';
    }

    var wrapper = input.closest('.slpw__field');
    var out = wrapper && wrapper.querySelector('[data-err-for]');
    if (wrapper) wrapper.classList.toggle('is-invalid', !!msg);
    if (out) out.textContent = msg;
    input.setAttribute('aria-invalid', msg ? 'true' : 'false');
    return msg;
  }

  /* ---------- main init ---------- */

  function init(root) {
    if (root.dataset.slpwReady) return;
    root.dataset.slpwReady = '1';

    var form = root.querySelector('[data-slpw-form]');
    var success = root.querySelector('[data-slpw-success]');

    // Scroll to the confirmation after Shopify reloads the page
    if (success) {
      success.scrollIntoView({ behavior: 'smooth', block: 'center' });
      success.focus({ preventScroll: true });
      return;
    }
    if (!form) return;

    var summary = form.querySelector('[data-slpw-summary]');
    var submit = form.querySelector('[data-slpw-submit]');
    var label = form.querySelector('[data-slpw-label]');
    var fields = Array.prototype.slice.call(
      form.querySelectorAll('input[type=text], input[type=email], input[type=tel], select, textarea')
    );

    // Live validation after the first blur
    fields.forEach(function (f) {
      f.addEventListener('blur', function () { validateField(f); });
      f.addEventListener('input', function () {
        if (f.getAttribute('aria-invalid') === 'true') validateField(f);
      });
    });

    form.addEventListener('submit', function (e) {
      var firstBad = null;
      var count = 0;
      fields.forEach(function (f) {
        if (validateField(f)) {
          count++;
          if (!firstBad) firstBad = f;
        }
      });

      if (firstBad) {
        e.preventDefault();
        if (summary) {
          summary.hidden = false;
          summary.textContent = 'Please fix ' + count + ' field' + (count > 1 ? 's' : '') + ' below and send again.';
        }
        firstBad.focus();
        return;
      }

      if (summary) summary.hidden = true;
      if (submit) submit.disabled = true;
      if (label) label.textContent = 'Sending…';
    });

    // Restore the button if the user comes back with the browser back button
    window.addEventListener('pageshow', function () {
      if (submit) submit.disabled = false;
    });
  }

  function boot() {
    document.querySelectorAll('[data-slpw]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // Theme editor support
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();
})();
